import { fromPromise } from 'rxjs/internal-compatibility';
export { Subject, forkJoin, empty, of, timer, from, defer, Observable, interval, concat as concatObs, merge as mergeObs, race as raceObs, throwError as throwObs, } from 'rxjs';
export * from 'rxjs/operators';
export * from './ofType';
export * from './waitForType';
export { fromPromise };
//# sourceMappingURL=rx.js.map